import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

import InputSkeleton from '../../../components/common/InputSkeleton';
import { Accept, GeneralInfoIcon, GeneralTermsIcon, ImportantDiscliamer, LegalAdviceIcon, WarentyIcon, WellComeIcon } from '../../../components/common/SvgIcon';

const disclaimerItems = [
  {
    title: __('General Terms', 'legal-pages'),
    description: __('By using this plugin, you agree to be bound by these terms and conditions. This plugin is designed to help you create legal documents for your website, but does not replace professional legal advice.', 'legal-pages'),
    icon: <GeneralTermsIcon />,
  },
  {
    title: __('No Legal Advice', 'legal-pages'),
    description: __('The templates and content provided by this plugin are for informational purposes only and do not constitute legal advice. We strongly recommend consulting with a qualified attorney for your specific legal needs.', 'legal-pages'),
    icon: <LegalAdviceIcon />,
  },
  {
    title: __('General Information Only', 'legal-pages'),
    description: __('The legal page templates are provided as starting points. They may not be suitable for all jurisdictions or business types. You are responsible for ensuring any documents meet your specific requirements.', 'legal-pages'),
    icon: <GeneralInfoIcon />,
  },
  {
    title: __('No Warranties', 'legal-pages'),
    description: __('This plugin and its templates are provided "as is" without warranty of any kind. We do not guarantee that the templates will meet your requirements or that they are error-free.', 'legal-pages'),
    icon: <WarentyIcon />,
  },
];

const DisclaimerScreen = ({ onAccept, isSubmitting = false, isLoading = false }) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = () => {
    if (isChecked && !isSubmitting) {
      onAccept();
    }
  };

  if (isLoading) {
    return (
      <div className="p-6 min-h-screen bg-gray-50">
        <InputSkeleton numberOfRows={15} SkeletonHeight={30} />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-6">
      <div className='max-w-3xl mx-auto'>
          <div className="flex justify-center mb-6">
            <WellComeIcon />
          </div>

          <div className="text-[28px] font-bold text-center text-[#17171C]">
            {__('Welcome to Legal Pages', 'legal-pages')}
          </div>

          <div className="mt-3 text-base text-center text-[#6F6F7B]">
            {__('divlease read and accept the following disclaimer before proceeding', 'legal-pages')}
          </div>
          <div className="bg-white rounded-xl shadow-lg border border-[#E4E4E780] mt-9">
            <div className="mt-6 flex items-center gap-3 rounded-xl bg-[#F8FAFF] px-4 py-3">
              <span className="grid h-10 w-10 place-items-center rounded-xl bg-[#FFF3F2]">
                <ImportantDiscliamer />
              </span>
              <div className="text-[19px] font-semibold text-[#17171C]">
                {__('Important Disclaimer', 'legal-pages')}
              </div>
            </div>
            <div className="mt-5 space-y-3">
              {disclaimerItems.map((item, index) => (
                <div key={index} className="rounded-xl bg-[#F4F4F580] px-4 py-4">
                  <div className="flex items-start gap-4">
                    <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#F3EFFF]">
                      {item.icon}
                    </div>
                    <div>
                      <div className="text-[15px] font-semibold text-[#17171C]">
                        {item.title}
                      </div>
                      <p className="mt-2 text-sm text-[#6F6F7B] leading-5">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        {/* Checkbox */}
        <div className="mx-auto mt-6 max-w-3xl rounded-2xl bg-white p-6 shadow">
          <div className="flex items-start">
            <input
              id="disclaimer-agree"
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              disabled={isSubmitting}
              className="mt-1 h-5 w-5 rounded border-[#7C3BED] text-[#7C3BED]"
            />
            <div className="ml-3 mt-[-10px] space-y-1">
              <div className="text-sm font-semibold text-[#17171C]">
                {__('I have read and agree to the disclaimer', 'legal-pages')}
              </div>
              <div className="text-sm text-[#6F6F7B]">
                {__('You must accept this disclaimer to use the Legal Pages plugin', 'legal-pages')}
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <div className="mx-auto max-w-3xl px-4 py-4">
            <button
              onClick={handleSubmit}
              disabled={!isChecked || isSubmitting}
              className={`w-full rounded-xl px-6 py-3.5 text-sm font-semibold text-white
                flex items-center justify-center gap-2 shadow-[0px_4px_14px_-2px_#7C3BED40];
                ${
                  isChecked && !isSubmitting
                    ? 'bg-[#7C3BED] hover:bg-[#6D4DFF]'
                    : 'bg-[#7C3BED40] cursor-not-allowed'
                }`}
            >
              <Accept className="w-5 h-5" />

                <span className='text-[17px] font-semibold'>
                {isSubmitting
                  ? __('Processing...', 'legal-pages')
                  : __('Accept & Continue', 'legal-pages')}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerScreen;
